import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

export const Header = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/step2');
  };
  return (
    <header>
      <div className='container'>
        <div className='headerWrapper'>
          <Link to='/'>
            <h1 className='logo '>Lepronth</h1>
          </Link>
          <div  className='menu'>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="#aboutus">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <button className='button' onClick={handleNext}>Get Started</button>
        </div>
      </div>
    </header>
  )
}
